/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackProcedimentiSettore =
  (typeof GetBackProcedimentiSettore)[keyof typeof GetBackProcedimentiSettore];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackProcedimentiSettore = {
  PROCEDIMENTO_AMMINISTRATIVO: 'PROCEDIMENTO_AMMINISTRATIVO',
  BANDO: 'BANDO',
} as const;
